import { show } from "../../../../MapStore2/web/client/actions/notifications";
import { Action } from "redux";

export type NotificationPosition = "tc" | "bc";
export const NotificationPosition = {
    TOP_CENTER: "tc" as NotificationPosition,
    BOTTOM_CENTER: "bc" as NotificationPosition,
};

export enum NotificationLevel {
    SUCCESS = "success",
    WARNING = "warning",
    INFO = "info",
    ERROR = "error",
}

export interface Notification {
    title: string;
    message: string;
    autoDismiss?: number;
    position?: NotificationPosition;
}

export const showError = (error: Notification) => showNotification(error, NotificationLevel.ERROR) as Action;

export const showWarning = (notification: Notification) => showNotification(notification, NotificationLevel.WARNING);

export const showNotification = (notification: Notification, level: NotificationLevel) => {
    return show(
        {
            title: notification.title,
            message: notification.message,
            autoDismiss: notification.autoDismiss ?? 1,
            position: notification.position ?? "tc",
        },
        level
    );
};
